<template>
	<a
		:href="`/courses/${ course.slug }/`"
		class="card"
	>
		<figure
			class="card-image"
			v-if="course.featured_image"
			ref="image"
		>
			<img :src="getImageUrl(course.featured_image, 'large')" alt="" role="presentation" loading="lazy" />
		</figure>

		<article class="card-content pt-4">
			<h3 class="title mb-3" v-html="course.title.rendered"></h3>
			<p class="description" v-html="course.acf.summary"></p>
		</article>
	</a>
</template>

<script>
import image from '@gearset/web-core/helpers/image.js';

export default {
	props: {
		course: {
			type: Object,
			required: true,
		},
	},
	methods: {
		getImageUrl(featuredImage, size) {
			return image(featuredImage, size);
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.card {
	overflow: hidden;
	text-align: left;
	display: flex;
	flex-direction: column;
	height: 100%;
	transition: transform .2s ease-in-out;
	box-shadow: none;
	border-radius: 0;
	background: none;

	&:hover,
	&.is-hoverable:hover {
		transform: scale(1.04);
	}

	article.card-content {
		padding-inline: 0;
		height: 100%;
		padding-bottom: 0;

		.description {
			font-weight: normal;
			color: $navy;
		}
	}

	figure.card-image img {
		width: 100%;
		display: block;
		border-radius: 0;
	}

	.title {
		font-size: $size-3;
		line-height: 1.5;
	}

	p.description {
		font-size: $size-5;
	}
}
</style>
